import React, { useCallback, useEffect, useLayoutEffect, useState } from "react";

const useModeContinuous = () => {
  const [isModeContinuous, setIsModeContinuous] = useState<boolean>(false);

  const process = useCallback(() => {
    const res = localStorage.getItem("MODE_CONTINUOUS");
    if (typeof res === "string") {
      switch (res) {
        case "1":
          setIsModeContinuous(true);
          break;
        default:
        case "0":
          setIsModeContinuous(false);
          break;
      }
    } else {
      setIsModeContinuous(false);
    }
  }, []);

  useLayoutEffect(() => {
    process();
    const id = setInterval(() => {
      process();
    }, 500);
    return () => {
      clearInterval(id);
    };
  }, [process]);

  const toggleModeContinuous = useCallback((checked: boolean) => {
    switch (checked) {
      case true:
        localStorage.setItem("MODE_CONTINUOUS", "1");
        setIsModeContinuous(true);
        break;
      case false:
        localStorage.setItem("MODE_CONTINUOUS", "0");
        setIsModeContinuous(false);
        break;
    }
  }, []);

  return {
    isModeContinuous,
    toggleModeContinuous,
  };
};

export { useModeContinuous };
